<template>
  <section class="amount-review">
    <div class="review-heading"><strong>核对应付金额</strong><span>{{ value.originalAmount == null ? '申请金额未填报' : '原申请 ¥ ' + value.originalAmount }}</span></div>
    <p class="review-hint">{{ value.mode === 'TOTAL' ? '本单未填写费用明细，请核定整单应付金额并填写依据。' : '保留原申请金额；金额有调整时请填写原因。' }}</p>
    <template v-if="value.kind === 'EXPENSE' && value.mode !== 'TOTAL'">
      <div v-for="(line, index) in value.lines" :key="line.id" class="review-line">
        <div class="line-heading"><strong>{{ index + 1 }}. {{ line.label }}</strong><span>申请 ¥ {{ line.originalAmount }}</span></div>
        <div class="review-fields">
          <el-form-item label="核定金额（元）"><el-input v-model="line.approvedAmount" :disabled="disabled" inputmode="decimal" /></el-form-item>
          <el-form-item label="调整原因"><el-input v-model="line.reason" :disabled="disabled" maxlength="500" placeholder="金额有调整时必填" /></el-form-item>
        </div>
      </div>
    </template>
    <div v-else class="review-fields">
      <el-form-item :label="value.mode === 'TOTAL' ? '整单核定金额（元）' : '核定金额（元）'" :required="value.mode === 'TOTAL'"><el-input v-model="value.approvedAmount" :disabled="disabled" inputmode="decimal" /></el-form-item>
      <el-form-item :label="value.mode === 'TOTAL' ? '核定依据' : '调整原因'" :required="value.mode === 'TOTAL'"><el-input v-model="value.reason" :disabled="disabled" maxlength="500" :placeholder="value.mode === 'TOTAL' ? '核定为0元也须说明原因' : '金额有调整时必填'" /></el-form-item>
    </div>
    <div class="review-total">核定应付 <strong>¥ {{ total }}</strong></div>
  </section>
</template>
<script>
const { reviewTotal } = require('@/utils/amount-review')
export default { props: { value: Object, disabled: Boolean }, computed: { total() { try { return reviewTotal(this.value) } catch (_) { return '—' } } } }
</script>
<style scoped>
.amount-review{background:#f7f9fd;border:1px solid #e1e8f2;border-radius:10px;padding:14px;margin-bottom:18px;color:#34445b}
.review-heading,.line-heading,.review-total{display:flex;align-items:center;justify-content:space-between;gap:12px}
.review-heading span,.line-heading span,.review-hint{font-size:12px;color:#8290a4}
.review-hint{margin:6px 0 12px}
.review-line{background:white;border:1px solid #e7edf5;border-radius:8px;padding:10px 12px;margin-bottom:8px}
.line-heading{align-items:flex-start;line-height:1.6;margin-bottom:8px}
.line-heading strong{font-size:13px;overflow-wrap:anywhere}
.line-heading span{flex-shrink:0}
.review-fields{display:grid;grid-template-columns:128px minmax(0,1fr);gap:12px;align-items:start}
.amount-review .review-fields .el-form-item{min-width:0;margin-bottom:0}
.review-fields ::v-deep .el-form-item__label{padding-bottom:6px;font-size:13px;line-height:20px}
.review-fields ::v-deep .el-input{width:100%}
.review-total{padding-top:10px;font-size:13px}
.review-total strong{font-size:20px;color:#4480f3}
@media(max-width:480px){.review-fields{grid-template-columns:104px minmax(0,1fr);gap:8px}}
</style>
